






























import { AvatarSize } from '@getaccept/lib-ui';
import type { ComputedRef, PropType, Ref } from '@vue/composition-api';
import { computed, toRefs, ref, defineComponent } from '@vue/composition-api';
import { ChatHelper } from '../helpers/chat.helper';
import type { ChatParticipant, LastReadBy } from '../types';
export default defineComponent({
  name: 'MessageReadBy',
  props: {
    reads: {
      type: Array as PropType<Array<LastReadBy>>,
      default: () => [],
    },
  },
  setup(props) {
    const { reads } = toRefs(props);
    const getName = (participant: ChatParticipant): string =>
      participant.recipient?.fullName ||
      participant.recipient?.email ||
      participant.user?.fullName ||
      participant.user?.email;

    const getThumbUrl = (participant: ChatParticipant): string =>
      participant.recipient?.thumbUrl || participant.user?.thumbUrl;

    const avatars: ComputedRef<
      {
        name: string;
        thumbUrl: string;
        timestamp: string;
        id: string;
      }[]
    > = computed(() =>
      reads.value.map(({ readBy }: LastReadBy) => ({
        id: readBy.participant.recipientId || readBy.participant.userId,
        name: getName(readBy.participant),
        thumbUrl: getThumbUrl(readBy.participant),
        timestamp: ChatHelper.fullTimestamp(readBy.timestamp),
      }))
    );

    const showModal: Ref<boolean> = ref(false);

    const toggleModal = (isOpen: boolean): void => {
      showModal.value = isOpen;
    };

    return { AvatarSize, avatars, showModal, toggleModal };
  },
});
